// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260504/js/" + chunkId + "." + {"44":"65550756","225":"bd03431a","481":"24d7ad8b","486":"34c747b9","770":"e65a0821"}[chunkId] + ".0.5144187693621347.chunk.js";
};